import React from 'react'
import { Select, Tag } from 'antd'

const TRAIN_TYPE_MAP: Record<string, string> = {
  pytorch: 'PyTorch',
  tensorflow: 'TensorFlow',
  paddle: 'PaddlePaddle',
  xgboost: 'XGBoost',
  mxnet: 'MXNet',
  mpi: 'MPI',
}

const TrainTypeTag = ({ value }: { value: string }) => {
  return <Tag color='blue'>{TRAIN_TYPE_MAP[value]}</Tag>
}

type TrainTypeSelectorProps = {
  disabled?: boolean
  value?: string
  onChange?: (value: string) => void
  editable?: boolean
}

const TrainTypeSelector: React.FC<TrainTypeSelectorProps> = ({
  disabled,
  value,
  onChange,
  editable = true,
}) => {
  return editable ? (
    <Select value={value} onChange={onChange} disabled={disabled}>
      {Object.keys(TRAIN_TYPE_MAP).map(key => (
        <Select.Option key={key} value={key}>
          <TrainTypeTag value={key} />
        </Select.Option>
      ))}
    </Select>
  ) : (
    <TrainTypeTag value={value || 'pytorch'} />
  )
}

export default TrainTypeSelector
